/* global gsap, ScrollTrigger */

/**
 * Map intro animation
 */
export default function () {
    if (typeof window === 'undefined') return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    const sections = document.querySelectorAll('.map-intro');
    if (!sections.length) return;

    function parseStat(el) {
        const raw = el.textContent.trim();
        const match = raw.match(/([\d,]+\.?\d*)/);
        if (!match) return null;

        const numStr = match[1].replace(/,/g, '');
        const end = parseFloat(numStr);
        const idx = raw.indexOf(match[1]);
        const prefix = raw.slice(0, idx);
        const suffix = raw.slice(idx + match[1].length);
        const useCommas = match[1].includes(',');

        return { end, prefix, suffix, useCommas };
    }

    // ─── Run independently for each section ──────────────────────────────
    sections.forEach(function (section) {
        const line = section.querySelector('.map-intro__line');
        const description = section.querySelector('.map-intro__description');
        const right = section.querySelector('.map-intro__right');
        const statItems = gsap.utils.toArray('.map-intro__stat-item', section);
        const statCounts = gsap.utils.toArray('.map-intro__stat-item__count', section);

        if (!line || !right) return;

        gsap.set(line, { scaleY: 0 });
        gsap.set(description, { opacity: 0 });
        gsap.set(statItems, { opacity: 0 });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: right,
                start: 'top 85%',
                once: true,
            },
            defaults: { ease: 'power2.out' },
        });

        tl.to(line, { scaleY: 1, duration: 0.6 })
            .to(description, { opacity: 1, duration: 0.6, ease: 'power1.inOut' }, '<');

        tl.addLabel('statsStart', '>-0.2')
            .to(statItems, {
                opacity: 1,
                duration: 0.5,
                stagger: 0.12,
                ease: 'power1.inOut',
            }, 'statsStart');

        statCounts.forEach(function (countEl, i) {
            const parsed = parseStat(countEl);
            if (!parsed) return;

            const { end, prefix, suffix, useCommas } = parsed;
            const proxy = { val: 0 };
            const offset = i * 0.12;

            tl.to(proxy, {
                val: end,
                duration: 1.4,
                ease: 'power2.out',
                onUpdate: function () {
                    const rounded = Math.round(proxy.val);
                    const formatted = useCommas ? rounded.toLocaleString() : rounded;
                    countEl.textContent = prefix + formatted + suffix;
                },
            }, `statsStart+=${offset}`);
        });
    });
}
